<template>
  <div>
    <auth-forms-wrapper show-links width="390" >
      <template #form>
        <v-row>
          <v-col>
            <!-- <v-img
              width="100%"
              justify="center"
              rel="preload"
              align="center"
              class="mx-auto mt-n12"
              :src="$images.loggedOut"
            /> -->
          </v-col>
        </v-row>

        <v-row>
          <v-col class="text-center mt-n8">
            <h3 class="text--primary font--secondary">
              {{kcErrorTitle}}
            </h3>
            <p :class="['mt-6 mb-2 body-2', { 'text-left': kcErrorPrompt }]" v-html="kcErrorDescription"></p>
            <a v-if="!kcErrorPrompt" class="text-decoration-none link-style body-2" href="mailto:support@maropost.com?subject=Support">
              Contact Support
            </a>
          </v-col>
        </v-row>

        <v-row class="mt-0">
          <v-col class="text-center py-5">
            <v-btn
              block
              x-large
              color="loginBtn"
              class="font-weight-bold white--text"
              @click="onLogin"
              v-track="'keycloak-auth__page-login-again-btn'"
            >
              Login Again
            </v-btn>
          </v-col>
        </v-row>
      </template>
    </auth-forms-wrapper>
  </div>
</template>

<script>
import AuthFormsWrapper from "@/components/shared/AuthFormsWrapper.vue";

/**
 * AuthIssue view
 */
export default {
  name: "AuthIssue",
  /**
  |--------------------------------------------------
  | Data Properties
  |--------------------------------------------------
  */
  data() {
    return {
      kcErrorTitle: 'Something Went Wrong!',
      kcErrorDescription: 'Try again, if the problem still persists',
      kcErrorPrompt: false
    };
  },
  /**
  |--------------------------------------------------
  | Components
  |--------------------------------------------------
  */
  components: {
    AuthFormsWrapper,
  },
  mounted() {
    if (this.$route.query && this.$route.query.error) {
      this.kcErrorPrompt = true;
      switch (this.$route.query.error) {
        case "invalid_grant":
          this.kcErrorTitle = ' Invalid credentials';
          this.kcErrorDescription = 'The credentials you provided are incorrect. Please try again.';
          break;
        case "access_denied":
          this.kcErrorTitle = ' Access Denied';
          this.kcErrorDescription = `The selected passkey may have been deleted or is no longer valid on this device. <br> <br>
          Please register a new passkey to continue.`;
          break;
        default:
          this.kcErrorTitle = ' An unknown error occurred';
      }
    }
  },
  methods: {
    onLogin () {
      window.location.replace(window.location.origin);
    }
  }
};
</script>
<style lang="scss" scoped>
.link-style {
  color: #4a94d9;
  margin-top: 15px;
  display: block;
}
</style>
